import { FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import { useCallback, useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AGREEMENT_KINDS } from "../../../../schemas/agreements";

export const AgreementKindSelection = (props) => {
    const { t } = useTranslation();
    const { selectedKind, setSelectedKind, parentAgreementKind, readonly = false } = props;

    const parentKindIndex = useMemo(() => {
        if (!parentAgreementKind) {
            return -1;
        }
        return AGREEMENT_KINDS.findIndex((kind) => kind.key === parentAgreementKind);
    }, [parentAgreementKind]);

    const isKindDisabled = useCallback(
        (kindIndex) => {
            if (parentKindIndex === -1) {
                return false;
            }
            return kindIndex <= parentKindIndex;
        },
        [parentKindIndex],
    );

    useEffect(() => {
        if (parentAgreementKind) {
            const selectedKindIndex = AGREEMENT_KINDS.findIndex((k) => k.key === selectedKind);
            if (isKindDisabled(selectedKindIndex)) {
                const firstValidKind = AGREEMENT_KINDS.find((_, index) => !isKindDisabled(index));
                if (firstValidKind) {
                    setSelectedKind(firstValidKind.key);
                }
            }
        }
    }, [isKindDisabled, parentAgreementKind, selectedKind]);

    return (
        <Grid container spacing={2} justifyContent="center" alignItems="center" marginTop={2}>
            <Grid item xs={12}>
                <Typography>{t("agreements.AgreementKindSelector.selectAgreementKind")}</Typography>
                {parentAgreementKind && (
                    <Typography variant="caption" color="text.secondary">
                        {t("agreements.AgreementKindSelector.transformingFrom", {
                            kind: t(
                                AGREEMENT_KINDS.find((k) => k.key === parentAgreementKind)
                                    ?.translationKey || "",
                            ),
                        })}
                    </Typography>
                )}
            </Grid>
            <Grid item>
                <RadioGroup value={selectedKind} onChange={(e) => setSelectedKind(e.target.value)}>
                    {AGREEMENT_KINDS.map((kind, index) => (
                        <FormControlLabel
                            key={kind.key}
                            value={kind.key}
                            control={<Radio />}
                            label={t(kind.translationKey)}
                            disabled={readonly || isKindDisabled(index)}
                        />
                    ))}
                </RadioGroup>
            </Grid>
        </Grid>
    );
};
